import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const VerticalMedium = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="4px"
        height="200px"
        viewBox="0 0 4 200"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <path
                fill={color}
                d="M3.2,197.9c0-0.2,0.2-0.5,0.2-0.6c-0.1-0.4,0-0.5,0.1-0.6c0.4-0.3,0.1-1,0.2-1.5c-0.5-0.6,0-1.2,0-1.9
        		c-0.1-0.4-0.2-0.9-0.1-1.2c0.2-0.9,0.2-1.9,0.1-2.8c0-0.6,0-0.9,0.3-1.3c-0.3-0.1-0.5-0.2-0.7-0.4c0.6-1.1,0.6-2.3,0.3-3.6
        		c0.1-0.3,0.2-0.5,0.3-0.7c-0.1-0.3-0.2-0.5-0.2-0.7c-0.1-0.2-0.1-0.4-0.2-0.8c0.1-0.1,0.3-0.2,0.3-0.3c-0.1-0.8-0.2-1.5-0.2-2
        		c0.2-1,0.1-2,0-3c-0.1-1-0.3-2.1,0.2-2.8c-0.1-0.5-0.1-0.8-0.1-1.2c0-0.4,0.1-0.8,0.2-1.1c-0.3-0.2-0.4-0.6-0.3-1.3
        		c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.6,0.1-1.3-0.3-1.5c0.2-0.5,0.3-1,0.4-1.5c-0.2-0.3-0.3-0.6-0.5-0.9c0.2-0.1,0.3-0.2,0.4-0.3
        		c0-0.6,0-1.1-0.3-1.1c0-0.4,0-0.8,0-1.2c0-0.3-0.1-0.6,0-0.8c0.1-0.7,0.4-1.4,0-2.1c0,0,0-0.2,0-0.3c0.2-0.5,0-1.1,0.1-1.6
        		c0-0.3,0.1-0.5,0.2-0.8c-0.2-0.9-0.2-0.9,0-2.8c-0.1,0-0.2-0.1-0.4-0.1c0.2-1.4,0.4-2.7,0.1-4.1c0.2-1-0.3-2.3,0.2-2.9
        		c-0.1-0.5-0.2-0.9-0.2-1.3c0.1-0.3,0.2-0.5,0.4-0.8c-0.2-0.2-0.3-0.4-0.3-0.4c0-0.8,0.1-1.4,0.1-2c0-0.7-0.1-1.3,0.1-1.9
        		c0.1-0.2,0.1-0.4,0.1-0.7c-0.2-0.1-0.3-0.1-0.5-0.2c0.1-0.7,0.2-1.3,0.3-1.9c0-0.1,0-0.2,0-0.3c-0.1-0.3-0.3-0.7-0.4-1
        		c0.1-0.1,0.2-0.2,0.3-0.4c-0.1-0.5-0.2-0.9-0.1-1.2c0-0.3,0.2-0.5,0.3-0.7c-0.1-0.5-0.3-1-0.2-1.4c0.1-1.7,0-3.5,0.2-5.2
        		c0-0.2,0.1-0.6,0-0.7c-0.4-1.1,0.1-2.3-0.1-3.4c0.5-0.8,0.1-1.3-0.2-1.8c0.4-0.6,0.5-1.3,0.2-2.2c0-0.1-0.1-0.4,0-0.6
        		c0.2-0.9-0.1-1.6-0.4-2.1c0.2-0.2,0.3-0.3,0.3-0.4c-0.1-1,0.1-2,0-3c0-1.3-0.3-2.5-0.1-3.9c-0.2-0.8,0-1.5,0.1-2.2
        		c0-0.3,0.1-0.7,0-0.8c-0.5-0.7-0.1-1.3,0-1.9c-0.3-1.2-0.3-1.3,0.3-1.4c-0.2-0.3-0.4-0.6-0.6-0.9c0.4-0.7-0.1-1.9,0.4-2.7
        		c-0.2-0.2-0.4-0.4-0.5-0.5c0.2-0.6,0.4-1.1,0.6-1.7c-0.4-0.9,0-2-0.1-3c-0.1,0-0.2,0-0.3,0c-0.1-0.9,0-1.6,0.4-2.1
        		c-0.1-0.6-0.5-0.9-0.3-1.6c0.3-1-0.1-1.1-0.3-1.5c0.2-0.5,0.7-0.8,0.2-1.7c0.2-0.3,0.3-0.5,0.5-0.7c-0.1-0.5-0.2-0.9-0.3-1.2
        		c0.1-0.2,0.2-0.3,0.3-0.4c-0.1-0.5-0.2-1-0.3-1.5c0.1-0.2,0.2-0.3,0.4-0.5c-0.2-0.3-0.3-0.5-0.5-1c0.2-0.2,0.3-0.3,0.5-0.5
        		C3.5,81,3.4,80,3.5,79.2c0.2-1.2,0.1-2.3,0-3.3c0-0.5,0-1.1,0.1-1.5c0.1-0.6-0.3-0.8-0.2-1.3c0.1-0.2,0.3-0.5,0.4-0.7
        		c-0.2-0.5-0.3-0.9-0.5-1.3c0.1-0.6,0.3-1.1,0.4-1.7c-0.1-0.2-0.2-0.4-0.3-0.5c0-0.3,0-0.6,0.1-0.8c0-0.3,0-0.7,0-1
        		c0.1-0.7,0.3-1.4-0.1-1.9c0.2-0.8-0.1-1.8,0.3-2.5c0.1-0.3,0.1-0.7-0.1-0.8c-0.2-0.1-0.2-0.4-0.2-0.8c0-0.2-0.1-0.4-0.2-0.6
        		c0.1-0.2,0.1-0.3,0.2-0.4c0.1-0.2,0.2-0.3,0.2-0.3c-0.1-0.3-0.1-0.5-0.1-0.7c0-0.5,0.1-1,0.2-1.5c0.1-0.9-0.1-1.3-0.5-1.6
        		c0,0,0-0.2-0.1-0.4c0.2,0,0.4,0,0.7,0.1c-0.1-0.5-0.1-0.8-0.1-1.1c0-0.3-0.1-0.6,0-0.8c0.1-0.2,0.2-0.3,0.5-0.5
        		c-0.2-0.5-0.3-0.9-0.5-1.4c0-0.4,0.1-1,0.1-1.4c0.2-1.2,0.2-1.2-0.2-1.9c0.3-0.4,0.4-1.2,0.3-1.8c-0.1-0.6-0.1-1,0-1.5
        		c0-0.7,0.1-1.3-0.1-2c-0.1-0.4,0-0.8,0.1-1.2c0.1-0.6,0.1-1-0.2-1.1c-0.2-1.3,0.3-2.4,0.4-3.7c-0.2,0.1-0.3,0.2-0.4,0.3
        		c-0.1-1,0.1-1.5,0.5-1.9c-0.2-0.6-0.2-0.8-0.2-1.7c0-0.1,0-0.3,0-0.4c-0.3-0.5-0.2-1,0-1.5c0.1-0.2,0-0.9,0-0.9
        		c-0.3-0.2-0.1-0.9-0.2-1c-0.3-0.6,0.1-0.9,0.1-1.4c-0.1-0.5-0.2-1,0-1.6c0.1-0.3,0-1.2,0-1.8c-0.1-0.8,0.1-1.3,0.3-2
        		c-0.1-0.2-0.2-0.3-0.4-0.5c0.2-0.5,0.3-0.8,0.4-1.3c-0.5-0.5-0.4-1.3-0.3-2.1c0.1-0.3,0.1-0.7,0.2-1.2c-0.2,0.1-0.3,0.2-0.5,0.4
        		c0.1-0.6,0-1.3,0.2-1.5c0.4-0.7,0.3-1.1,0-1.9c-0.2-0.6-0.2-1.6-0.2-2.4c0-0.4,0.2-0.8,0.4-1.2c-0.3-0.7-0.4-1.3-0.4-1.8
        		C3.5,9,3.5,7.3,3.4,6.5c-0.1-0.6,0-1.1,0.3-1.2c0,0,0.1-0.2,0.1-0.4c-0.1,0-0.2,0-0.4,0c0.1-1.1,0.1-2.1,0.2-2.8
        		C3.4,1.6,3.3,1.3,3.2,1C3,0.6,2.8,0.1,2.6,0L2.3,1.2c0,0.7-0.1,1.8-0.2,2.9c0.1,0,0.2,0,0.4,0C2.4,4.3,2.4,4.4,2.4,4.4
        		C2,4.6,2,5.1,2.1,5.7c0,0.3,0.1,0.8,0.1,1.4c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0C2.1,8,2,8.7,2,9.1C1.9,9.7,2,10.3,2.3,11
        		c-0.1,0.4-0.4,0.8-0.4,1.2c0,0.8,0,1.8,0.2,2.5c0.2,0.8,0.4,1.2,0,1.9c-0.1,0.2-0.1,0.9-0.2,1.6c0.2-0.1,0.3-0.2,0.5-0.4
        		c-0.1,0.5-0.1,0.9-0.2,1.2c-0.2,0.9-0.3,1.7,0.3,2.2c0,0.1,0,0.1-0.1,0.2c0,0,0,0,0,0c0,0,0.1,0.1,0.2,0.3c-0.1,0-0.2,0.1-0.3,0.1
        		c0,0,0,0,0,0c-0.1,0.2-0.2,0.5-0.3,0.8c0.1,0.2,0.2,0.3,0.4,0.5c-0.2,0.7-0.4,1.2-0.3,2c0.1,0.6,0.2,1.5,0,1.8
        		c-0.3,0.7-0.1,1.2,0,1.7c0.1,0.5-0.4,0.9-0.1,1.5c0.1,0.1-0.1,0.8,0.2,1c0,0,0,0.1,0,0.3c0.1-0.1,0.1-0.2,0.1-0.2
        		c0,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1-0.1-0.1-0.2c0,0.2,0,0.4,0,0.6c-0.2,0.6-0.3,1,0,1.6c0,0.1,0,0.3,0,0.4
        		c0,0.9,0,1.1,0.2,1.8c-0.4,0.3-0.6,0.9-0.5,1.9c0.1-0.1,0.2-0.2,0.4-0.3c-0.1,1.4-0.6,2.4-0.4,3.8c0.3,0.2,0.4,0.5,0.2,1.2
        		c-0.1,0.4-0.2,0.8-0.1,1.2c0.2,0.7,0.1,1.4,0.1,2.1c0,0.5-0.1,1,0,1.6c0.1,0.6,0.1,1.4-0.3,1.8c0.5,0.7,0.4,0.7,0.2,1.9
        		c-0.1,0.5-0.1,1.1-0.1,1.5c0.2,0.5,0.3,0.9,0.5,1.4c-0.2,0.2-0.4,0.3-0.5,0.5c-0.1,0.1,0,0.5,0.1,0.8c0,0.3,0.1,0.6,0.1,1.1
        		c-0.3,0-0.5,0-0.7-0.1c0,0.2,0,0.4,0.1,0.4c0.5,0.4,0.6,0.7,0.5,1.7c0,0.5-0.1,1.1-0.2,1.6c0,0.2,0.1,0.5,0.1,0.7
        		c0,0-0.1,0.2-0.2,0.4c-0.1,0.1-0.1,0.3-0.2,0.5C1.9,61.7,2,61.9,2,62.2c0,0.4,0,0.7,0.2,0.8c0.2,0.2,0.2,0.5,0.1,0.8
        		c-0.3,0.7,0,1.8-0.3,2.6c0.5,0.5,0.2,1.2,0.1,1.9c0,0.3,0,0.7,0,1.1c0,0.3,0,0.6-0.1,0.9c0.1,0.2,0.2,0.3,0.4,0.6
        		C2.3,71.4,2.2,72,2,72.6c0.2,0.4,0.3,0.8,0.5,1.3c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.6,0.3,0.7,0.2,1.4c-0.1,0.4-0.1,1-0.1,1.5
        		c0.2,1,0.3,2.2,0,3.4c-0.2,0.8-0.1,1.8,0.3,2.7c-0.2,0.2-0.3,0.3-0.5,0.5c0.2,0.4,0.4,0.7,0.5,1c-0.1,0.2-0.3,0.4-0.4,0.5
        		c0.1,0.5,0.2,1,0.4,1.6c-0.1,0.1-0.1,0.2-0.3,0.4c0.1,0.4,0.2,0.7,0.3,1.3c-0.1,0.2-0.3,0.4-0.5,0.7c0,0,0,0,0,0
        		c0.2-0.2,0.4-0.1,0.6,0.1c-0.1,0.1-0.3,0.2-0.4,0.3c0.2,0.6-0.2,0.9-0.4,1.3c0.2,0.4,0.7,0.5,0.3,1.5c-0.2,0.8,0.2,1.1,0.3,1.7
        		C2.1,95.3,2,96,2.1,97c0.1,0,0.2,0,0.3,0c0.1,1-0.3,2.1,0.1,3.1c-0.2,0.6-0.4,1.1-0.6,1.8c0.2,0.2,0.4,0.4,0.6,0.5
        		c-0.5,0.8,0.1,2-0.4,2.8c0.2,0.3,0.4,0.6,0.7,0.9c-0.6,0.1-0.6,0.3-0.3,1.5c-0.1,0.6-0.6,1.2,0,1.9c0,0.1,0,0.5,0,0.8
        		c-0.1,0.6-0.3,1.2-0.2,1.8c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c-0.2,1.4,0.1,2.7,0.1,4c0,1-0.2,2.1,0,3.1
        		c0,0-0.2,0.2-0.3,0.4c0.3,0.6,0.5,1.3,0.4,2.2c0,0.2,0,0.4,0,0.6c0.3,0.9,0.2,1.6-0.2,2.2c0.3,0.6,0.7,1.1,0.2,1.9
        		c0.2,1.1-0.4,2.4,0.1,3.5c0.1,0.1,0,0.5,0,0.7c-0.2,1.8-0.1,3.6-0.2,5.4c0,0.4,0.2,0.9,0.3,1.4c-0.1,0.2-0.2,0.4-0.3,0.7
        		c0,0.4,0.1,0.8,0.1,1.2c-0.1,0.1-0.2,0.3-0.3,0.4c0.1,0.4,0.3,0.7,0.4,1.1c0,0.1,0,0.2,0,0.3c-0.1,0.7-0.2,1.3-0.3,2
        		c0.2,0.1,0.3,0.1,0.5,0.2c0,0.3-0.1,0.5-0.1,0.7c-0.2,0.6-0.2,1.2-0.1,1.9c0,0.6-0.1,1.2-0.1,2c0,0,0.2,0.2,0.3,0.4
        		c-0.2,0.3-0.3,0.5-0.4,0.8c0,0.2,0.1,0.4,0.1,0.6c0-0.1,0.1-0.2,0.1-0.2c0,0.3,0,0.5-0.1,0.7c0,0.1,0,0.2,0.1,0.3
        		c0,0-0.1,0.1-0.1,0.1c0.2-0.2,0.4,0.1,0.5,0.6c-0.2,0-0.3,0.1-0.5,0.1c0-0.3,0-0.5,0-0.7c-0.3,0.7,0.1,1.9-0.1,2.9
        		c0.3,1.4,0.1,2.8-0.1,4.3c0.1,0,0.3,0.1,0.4,0.1c-0.2,2-0.2,2,0,2.9c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.6,0.1,1.2-0.1,1.7
        		c0,0.1,0,0.2,0,0.3c0.3,0.8,0.1,1.5,0,2.2c0,0.2,0,0.6,0,0.9c0,0.4,0,0.8,0,1.2c0.4-0.1,0.4,0.5,0.3,1.1c-0.1,0.1-0.3,0.2-0.5,0.3
        		c0.2,0.4,0.3,0.6,0.5,0.9c-0.1,0.5-0.3,1-0.4,1.5c0.4,0.2,0.4,0.9,0.3,1.5c0,0.4-0.1,0.9-0.2,1.3c-0.1,0.7,0,1.1,0.3,1.3
        		c-0.1,0.4-0.2,0.8-0.2,1.2c0,0.4,0.1,0.7,0.1,1.2C2,179.8,2.2,181,2.2,182c0.1,1,0.2,2,0,3.1c-0.1,0.5,0.1,1.2,0.2,2
        		c0,0-0.1,0.1-0.3,0.3c0.1,0.4,0.2,0.6,0.2,0.8c0.1,0.2,0.1,0.4,0.2,0.7c-0.1,0.2-0.2,0.4-0.3,0.7c0.3,1.3,0.3,2.6-0.3,3.8
        		c0.3,0.2,0.5,0.3,0.8,0.4c-0.3,0.4-0.4,0.7-0.3,1.4c0.1,0.9,0.1,2-0.1,2.9c-0.1,0.3,0.1,0.8,0.2,1.2c0,0.2-0.1,0.5-0.1,0.7
        		c0.1,0,0.1,0,0.2,0c0.3-0.1,0.6-0.3,0.7-1c0-0.2,0.2-0.4,0.2-0.7C3.3,198.2,3.2,197.9,3.2,197.9z M2.5,8c-0.1-0.6,0-0.9,0.4-0.7
        		C2.7,7.6,2.6,7.8,2.5,8z M3,11.6c0-0.1,0.1-0.2,0.1-0.3c0,0.1,0.1,0.2,0.2,0.3c-0.1,0.2-0.1,0.3-0.1,0.4C3.1,11.8,3,11.7,3,11.6z
        		 M2.5,16.4c0,0,0-0.2,0-0.2c0.1,0,0.2,0,0.3-0.1c0,0.1,0,0.2,0,0.3C2.7,16.4,2.6,16.4,2.5,16.4z M2.7,19.9C3,19.7,3,19.7,3,20.5
        		C2.9,20.3,2.8,20.1,2.7,19.9z M2.2,33.4c0,0-0.1-0.2-0.1-0.3C2.2,33.1,2.2,33,2.3,33c0,0,0.1,0.1,0.2,0.3
        		C2.3,33.4,2.3,33.5,2.2,33.4z M3.1,35.2c0-0.1,0.1-0.2,0.1-0.4c0,0.1,0.1,0.2,0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3
        		C3.1,35.4,3.1,35.3,3.1,35.2z M2.5,41.6c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1,0.1-0.2,0.1-0.2c0,0,0.1,0.1,0.1,0.2
        		C2.6,41.3,2.5,41.4,2.5,41.6z M2.6,89.9c-0.1-0.6,0-0.7,0.4-0.6C2.8,89.6,2.7,89.7,2.6,89.9z M2.8,114.8c0.2,0.2,0.4,0.5,0.3,1.1
        		C2.9,115.6,2.7,115.5,2.8,114.8z"
            />
            <path fill={color} d="M1.2,92.1c0.1-0.1,0.2-0.3,0.4-0.6C1.2,91.4,1.1,91.5,1.2,92.1z" />
            <path
                fill={color}
                d="M1.5,117.8c-0.2,0.8,0.1,0.9,0.3,1.2C1.9,118.3,1.7,118.1,1.5,117.8z"
            />
            <path
                fill={color}
                d="M0.9,21.3c0,0.1,0,0.3,0.1,0.3c0.1,0,0.2,0,0.3-0.1c-0.1-0.2-0.1-0.3-0.2-0.3C1,21.2,1,21.2,0.9,21.3z"
            />
            <path fill={color} d="M1.3,19.6c0.1,0.2,0.2,0.4,0.3,0.6C1.6,19.4,1.6,19.4,1.3,19.6z" />
            <path
                fill={color}
                d="M1.1,15.7c0,0.1,0,0.2,0,0.2c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0-0.4C1.3,15.7,1.2,15.7,1.1,15.7z"
            />
            <path
                fill={color}
                d="M1.8,10.7c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.2,0.1,0.3c0-0.1,0.1-0.2,0.1-0.4C1.9,10.8,1.8,10.7,1.8,10.7z"
            />
            <path
                fill={color}
                d="M1.8,35.1c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.3C1.9,35.3,1.9,35.2,1.8,35.1z"
            />
            <path
                fill={color}
                d="M1.1,41.5c0,0-0.1,0.2-0.1,0.2C1,41.8,1,41.9,1.1,42c0-0.1,0.1-0.2,0.1-0.3C1.2,41.6,1.1,41.5,1.1,41.5z"
            />
            <path
                fill={color}
                d="M0.1,48.6c0,0-0.1,0.2-0.1,0.3c0,0.1,0.1,0.3,0.1,0.3c0.1,0,0.1-0.1,0.3-0.3C0.2,48.7,0.2,48.6,0.1,48.6z"
            />
            <path
                fill={color}
                d="M0.7,33.3c0,0.1,0.1,0.3,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.3-0.2-0.3C0.8,33.2,0.8,33.3,0.7,33.3z
        		"
            />
            <path
                fill={color}
                d="M1.1,31.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.1,0.1-0.2,0.2C1,31.7,1,31.8,1.1,31.8z"
            />
            <path
                fill={color}
                d="M0,35c0,0.1,0.1,0.2,0.1,0.3c0-0.1,0.1-0.2,0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3C0.1,34.8,0,34.9,0,35z"
            />
        </g>
    </svg>
);

VerticalMedium.propTypes = propTypes;
VerticalMedium.defaultProps = defaultProps;

export default VerticalMedium;
